module.exports = __webpack_public_path__ + "img/face47.590cbeac.gif";